import { forwardRef } from "react";

import { Field, Label } from "@/components/fieldset";
import { InputGroup } from "@/components/input";
import { cx } from "@/utils";
import { Select } from "..";

const SelectField = forwardRef(function SelectField(
  { label, className, ...props },
  ref,
) {
  return (
    <Field className="w-full">
      <Label>{label}</Label>
      <InputGroup>
        <Select
          className={cx("bg-transparent", className)}
          {...props}
          type="text"
          ref={ref}
        />
      </InputGroup>
    </Field>
  );
});

export default SelectField;
